// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

export const userEndPoint = "/api/v1/utilisateurs/:identifiant";
export const usersEndPoint = "/api/v1/utilisateurs";
